// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { postLabReviews } from '../../apis/lab';
import { postLabReviewsActions } from '../actionCreators/postLabReviewsActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: postLabReviewsActions.success,
  failure: postLabReviewsActions.failure
};

type RequestActionTypes = ActionType<
  typeof postLabReviewsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const postLabReviewsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(postLabReviewsActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, condition, ...others } = action.payload;
      // send api promise
      return postLabReviews(id, others, condition)
        .then(() => {
          // handle success case here
          return postLabReviewsActions.success();
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return postLabReviewsActions.failure({ error });
        });
    })
  );
};
